/**
 * Normalize AMCQ grade docs (correctQuestions / incorrectQuestions) for results UI.
 */

const letterIndex = (ch) => {
  const c = String(ch || 'a').toLowerCase().charCodeAt(0) - 97;
  return c >= 0 && c < 26 ? c : -1;
};

export function choiceTextForLetter(choices, letter) {
  const arr = Array.isArray(choices) ? choices : [];
  const i = letterIndex(letter);
  if (i < 0 || i >= arr.length) return '';
  return String(arr[i] || '');
}

export function explanationForLetter(explanations, letter) {
  const arr = Array.isArray(explanations) ? explanations : [];
  const i = letterIndex(letter);
  if (i < 0 || i >= arr.length) return '';
  return String(arr[i] || '');
}

export function choiceLettersForQuestion(q) {
  const n = Array.isArray(q?.choices) ? q.choices.length : 0;
  if (n <= 0) return ['a', 'b', 'c', 'd'];
  return Array.from({ length: n }, (_, i) => String.fromCharCode(97 + i));
}

function sortKey(row) {
  if (typeof row.order === 'number' && !Number.isNaN(row.order)) return row.order;
  const sn = Number(row.sectorNumber);
  const ds = parseFloat(row.difficultyScore);
  return (Number.isFinite(sn) ? sn * 1e6 : 0) + (Number.isFinite(ds) ? ds : 0);
}

/**
 * @param {{ correctQuestions?: any[], incorrectQuestions?: any[] }} grade
 * @returns {Array<object & { isCorrect: boolean }>}
 */
export function mergeAmcqGradeQuestions(grade) {
  const correct = Array.isArray(grade?.correctQuestions) ? grade.correctQuestions : [];
  const incorrect = Array.isArray(grade?.incorrectQuestions) ? grade.incorrectQuestions : [];
  const rows = [
    ...correct.map((q) => ({ ...q, isCorrect: true })),
    ...incorrect.map((q) => ({ ...q, isCorrect: false })),
  ];
  rows.sort((a, b) => sortKey(a) - sortKey(b));
  return rows;
}

export function submittedAtToDate(value) {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate();
  if (value instanceof Date) return value;
  return new Date(value);
}
